import { SonarObjectType } from '../../../global';
import { PeriscopeSfBaseRecord } from '.';
import { PeriscopeSummary } from '../PeriscopeSummary';

export type PeriscopeSfEmailAlert = PeriscopeSfBaseRecord;

export type PeriscopeSfEmailAlertSummary = PeriscopeSummary;

export enum EmailAlertRecipientType {
        AccountOwner = 'accountOwner',
        AccountTeam = 'accountTeam',
        CaseTeam = 'caseTeam',
        CampaignMemberDerivedOwner = 'campaignMemberDerivedOwner',
        ContactLookup = 'contactLookup',
        Creator = 'creator',
        CustomerPortalOwner = 'customerPortalOwner',
        Email = 'email',
        Group = 'group',
        OpportunityTeam = 'opportunityTeam',
        Owner = 'owner',
        PartnerUser = 'partnerUser',
        PortalRole = 'portalRole',
        PortalRoleSubordinates = 'portalRoleSubordinates',
        Role = 'role',
        RoleSubordinates = 'roleSubordinates',
        RoleSubordinatesInternal = 'roleSubordinatesInternal',
        User = 'user',
        UserLookup = 'userLookup'
}

export type PeriscopeSfEmailAlertRecipientField = {
	displayName: string,
	parentDisplayName: string,
	parentSonarObjectId: number,
	parentSonarObjectType: string,
	recipient: string;
	recipientType: EmailAlertRecipientType;
	sonarObjectId: number;
	sonarObjectType: SonarObjectType;
};

export type PeriscopeSfEmailAlertMetadata = {
	ccEmails: string;
	emailTemplateName: string;
	emailTemplateSonarObjectId: number;
	parentEntityName: string;
	parentEntitySonarObjectId: number;
	recipients: PeriscopeSfEmailAlertRecipientField[];
};
